
    var circularLayoutHelper = require('./circularLayoutHelper');
    module.exports = function (ecModel) {
        ecModel.eachSeriesByType('graph', function (seriesModel) {
            if (seriesModel.get('layout') === 'circular') {
                circularLayoutHelper(seriesModel);
            }
        });
    };



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/graph/circularLayout.js
// module id = 794
// module chunks = 0